var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleLeftNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.1659C9.87202 13.1659 9.744 13.1172 9.64666 13.0192L4.98 8.35256C4.78466 8.15722 4.78466 7.84053 4.98 7.6452L9.64666 2.97853C9.842 2.7832 10.1587 2.7832 10.354 2.97853C10.5494 3.17386 10.5494 3.49055 10.354 3.68589L6.04071 7.9992L10.354 12.3125C10.5494 12.5078 10.5494 12.8245 10.354 13.0199C10.256 13.1172 10.128 13.1659 10 13.1659Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeftNeutral);
export default __webpack_public_path__ + "static/media/angle-left_neutral.9d3f8e4bab76dac938af3152b184026a.svg";
export { ForwardRef as ReactComponent };